import axiosInstance from '../utils/axios';

export const googleCalendarService = {
  getStatus: async () => {
    const response = await axiosInstance.get('/google-calendar/status');
    return response.data;
  },

  getConnectUrl: async () => {
    const response = await axiosInstance.get('/google-calendar/connect-url');
    return response.data?.url;
  },

  disconnect: async () => {
    const response = await axiosInstance.post('/google-calendar/disconnect');
    return response.data;
  },

  /** Push events you can edit into Google (backfill; create/update already sync). */
  syncExisting: async () => {
    const response = await axiosInstance.post('/google-calendar/sync-existing');
    return response.data;
  },
};
